import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; // Import default CSS for Calendar
import "./calender.css"; // Custom styles for the calendar
import { Card, Form, Space, Table } from "antd";
import { API } from "../../config/api";
import { POST } from "../../utils/apicalls";
import { useNavigate } from "react-router-dom";
import { GrView } from "react-icons/gr";
import moment from "moment";

const Dashboard: React.FC = () => {
  const [date, setDate] = useState<Date | null>(new Date());
  const [holidays, setHolidays] = useState<{ [key: string]: string }>({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5000000000); // Define the page size
  const [data, setData] = useState<any>([]);

  const [projectdata, setprojectData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [meta, setMeta] = useState<any>({});
  const [metas, setsMeta] = useState<any>({});

  const [filterData, setFilterData] = useState<any>([]);
  const [form] = Form.useForm();
  const navigate = useNavigate();




  const [internData, setInternData] = useState<any>([]);

  const [profit, setProfit] = useState<number>(0);
  const [internProfit, setInternProfit] = useState<number>(0);
  const [loss, setLoss] = useState<number>(0);
  const [selectedMonth, setSelectedMonth] = useState<string>("");
  const [selectedYear, setSelectedYear] = useState<string>("");
  // const [monthlyData, setMonthlyData] = useState<any[]>([]);
  // const [categoryData, setCategoryData] = useState<any[]>([]);

  // Colors for charts
  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884D8', '#FF6B6B'];

  useEffect(() => {
    fetchSalary();
  }, [selectedMonth, selectedYear, page, pageSize]);

  useEffect(() => {
    fetchIntern(page, pageSize);
  }, [page, pageSize, selectedMonth, selectedYear]);

  // Calculate total values including internship data
  useEffect(() => {
    calculateTotals();
  }, [data, internData]);

  const calculateTotals = () => {
    // Calculate total profit from regular payments
    const totalProfit = data.reduce(
      (acc: number, item: any) => acc + (parseFloat(item.IN_Amount) || 0),
      0
    );

    // Calculate total profit from internships
    const totalInternProfit = internData.reduce(
      (acc: number, item: any) => acc + (parseFloat(item.PayementAmount) || 0),
      0
    );

    // Calculate total loss
    const totalLoss = data.reduce(
      (acc: number, item: any) => acc + (parseFloat(item.OUT_Amount) || 0),
      0
    );

    setProfit(totalProfit);
    setInternProfit(totalInternProfit);
    setLoss(totalLoss);

    // Update charts with combined data
    // generateMonthlyChartData(data, internData);
    // generateCategoryChartData(data, internData);
  };

  const fetchSalary = async () => {
    try {
      setIsLoading(true);
      const obj = {
        query: form.getFieldValue("query") || "",
        page: page,
        take: pageSize,
        month: selectedMonth || undefined,
        year: selectedYear || undefined,
      };

      const url = API.LIST_SALARY_DETAILS;
      const response: any = await POST(url, obj);

      if (response?.data) {
        let filteredData = response.data;

        // Filter by month if selected
        if (selectedMonth) {
          const monthNum = parseInt(selectedMonth);
          filteredData = filteredData.filter((item: any) => {
            const date = new Date(item.date);
            return date.getMonth() + 1 === monthNum;
          });
        }

        // Filter by year if selected
        if (selectedYear) {
          const yearNum = parseInt(selectedYear);
          filteredData = filteredData.filter((item: any) => {
            const date = new Date(item.date);
            return date.getFullYear() === yearNum;
          });
        }

        setData(filteredData);
        setMeta(response.meta || {});
      } else {
        setData([]);
        setMeta({});
      }
    } catch (error) {
      console.error("Error fetching salary details:", error);
      setData([]);
      setMeta({});
    } finally {
      setIsLoading(false);
    }
  };

  const fetchIntern = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: take,
        month: selectedMonth || undefined,
        year: selectedYear || undefined,
      };
      const url = API.LIST_INTERNSHIP_STUDENTS_DETAILS;
      const response: any = await POST(url, obj);

      if (response?.data) {
        let filteredData = response.data;

        // Filter by month if selected
        if (selectedMonth) {
          const monthNum = parseInt(selectedMonth);
          filteredData = filteredData.filter((item: any) => {
            const date = new Date(item.createdAt || item.createdAt);
            return date.getMonth() + 1 === monthNum;
          });
        }

        // Filter by year if selected
        if (selectedYear) {
          const yearNum = parseInt(selectedYear);
          filteredData = filteredData.filter((item: any) => {
            const date = new Date(item.createdAt || item.createdAt);
            return date.getFullYear() === yearNum;
          });
        }

        setInternData(filteredData);
      } else {
        setInternData([]);
      }
    } catch (error) {
      console.log("Error fetching internship details:", error);
      setInternData([]);
    } finally {
      setIsLoading(false);
    }
  };
  // Handle date change
  const handleDateChange = (value: any | [Date, Date] | null) => {
    setDate(value);
  };
  const fetchHrEmployee = async (page: any) => {
    try {
      setIsLoading(true);
      let obj = {
        // query: form.getFieldValue("query"),
        page: page,
        take: pageSize,
      };
      const url = API.PAGENATION_EMPLOYEE;
      const response: any = await POST(url, obj);
      setData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrEmployee(page);
  }, [page]); // Fetch data on page or pageSize change

  const filterEmployee = async () => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        status: true,
      };
      const url = API.FILTER_EMPLOYEE;
      const response: any = await POST(url, obj);
      setFilterData(response?.data);
      setMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    filterEmployee(); // Fetch data when the component mounts
  }, []);

  const fetchHrproject = async (page: any, take: any) => {
    try {
      setIsLoading(true);
      let obj = {
        query: form.getFieldValue("query"),
        page: page,
        take: 5,
      };
      const url = API.PAGENATION_PROJECT;
      const response: any = await POST(url, obj);
      setprojectData(response?.data);

      setsMeta(response?.meta);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchHrproject(page, pageSize);
  }, [page, pageSize]);



  const columns = [
    {
      dataIndex: "projectName",
      title: "projectName",
    },
    {
      title: "status",
      dataIndex: "status",
    },
    {
      key: "assignedTo",
      dataIndex: "assignedTo",
      title: "assignedTo",
      render: (_: any, value: any) => <span>{value?.empid?.fullName}</span>,
    },
    {
      dataIndex: "clientid",
      title: "clientid",
      key: "clientid",
      render: (_: any, value: any) => <span>{value?.Client?.companyName}</span>,
    },
    {
      dataIndex: "endDate",
      title: "endDate",
      render: (end_date: any) =>
        end_date ? moment(end_date).format("DD/MM/YYYY") : "-",
    },

    {
      title: "Action",
      key: "id",
      render: (_: any, record: any) => (
        <Space size="middle">
          <GrView
            color="blue"
            size={20}
            onClick={() => navigate(`/Admin/Project/projectview/${record?.id}`)}
          />
        </Space>
      ),
    },
  ];
  const totalIncome = profit + internProfit;
  return (
    <div className="dashboard-container">
      <Card>
        <h2 style={{ fontSize: '24px', marginBottom: '20px' }}>Total Payments Dashboard</h2>
        {/* Summary Cards */}
        <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
          <Card title="Regular Income" style={{ flex: 1, backgroundColor: '#e6f7ff', borderColor: '#1890ff' }}>
            <h2 style={{ color: '#0088FE', fontSize: '24px' }}>₹{profit.toFixed(2)}</h2>
          </Card>
          <Card title="Internship Income" style={{ flex: 1, backgroundColor: '#e6fffb', borderColor: '#13c2c2' }}>
            <h2 style={{ color: '#00C49F', fontSize: '24px' }}>₹{internProfit.toFixed(2)}</h2>
          </Card>
          <Card title="Total Expense" style={{ flex: 1, backgroundColor: '#fff1f0', borderColor: '#ff4d4f' }}>
            <h2 style={{ color: '#FF8042', fontSize: '24px' }}>₹{loss.toFixed(2)}</h2>
          </Card>
          <Card title="Net Balance" style={{ flex: 1, backgroundColor: '#f6ffed', borderColor: '#52c41a' }}>
            <h2 style={{ color: totalIncome > loss ? '#00C49F' : '#FF6B6B', fontSize: '24px' }}>₹{(totalIncome - loss).toFixed(2)}</h2>
          </Card>
        </div>
      </Card>
      <div className="dashboard-container">
        <div className="dashboard-row">
          <Card className="calendar-card">
            <h3 className="selected-date">
              {date
                ? `Selected Date: ${date instanceof Date ? date.toDateString() : ""
                }`
                : "No date selected"}
            </h3>
            <div className="calendar-container">
              <Calendar
                onChange={handleDateChange} // Now accepts Date, Range, or null
                value={date}
                tileContent={({ date, view }) => {
                  const formattedDate = date.toISOString().split("T")[0];
                  if (view === "month" && holidays[formattedDate]) {
                    return (
                      <div className="holiday-marker">
                        {holidays[formattedDate]}
                      </div>
                    );
                  }
                  return null;
                }}
              />
            </div>
          </Card>
          <Card className="table-card">
            <Table
              columns={columns}
              dataSource={projectdata}
              pagination={{
                current: page,
                pageSize: pageSize,
                total: meta?.total_count,
                onChange: (page: any, pageSize: any) => {
                  setPage(page);
                  setPageSize(pageSize);
                },
              }}
            />
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
